module.exports = __webpack_public_path__ + "static/media/a-frame-scene-example.ba0c6fc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a-frame-scene-example.jpg
// module id = 1533
// module chunks = 0